import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';

import { Tooltip } from '../../Tooltip';
import { setCursor } from '../../../utilities';
import type { checkPromptFormattingErrors } from '../../../utilities';

type ValidatorProps = {
  editorRef: React.RefObject<HTMLDivElement>;
  errors: ReturnType<typeof checkPromptFormattingErrors>;
};

const Validator: React.FC<ValidatorProps> = ({ editorRef, errors }) => {
  return (
    !!errors.length && (
      <Tooltip
        className="h-full"
        iconClassName="h-full"
        customIcon={<WarningIcon fontSize="large" className="text-danger" />}
        trigger="click"
        content={
          <div className="flex flex-col max-h-[10rem] overflow-y-auto gap-y-md">
            {errors.map((e, index) => (
              <div
                key={index}
                className="cursor-pointer text-small"
                onClick={() =>
                  setCursor(editorRef.current, e.position, e.token.length)
                }
              >
                {e.message}
              </div>
            ))}
          </div>
        }
      />
    )
  );
};

export default Validator;
